import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";

import { notifyError } from "utils";
import store, { dispatch } from "store/store";
import { tasks as constants } from "store/constants";

import { awardTasksFactory, getAwardTasks, getProposalTasks, proposalTasksFactory } from "./taskList";
import { api } from "services";


const setCertificationIsFetching = payload => dispatch({ type: constants.CERTIFICATION_IS_FETCHING, payload });

const completeCertificationTask = async (request, params, payload) => {
	try {
		await request(params, payload);

	} catch (e) {
		const message = store.getState().dictionary.errors.unableToSave || "Unable to complete the certification";
		notifyError(message, e);
	}
};

export const completeCertificationAwardTask = async (taskId, submissionId, taskType, targetName, comment) => {
	setCertificationIsFetching(true);

	await completeCertificationTask(
		api.awards.updateCertifications,
		{ id: submissionId },
		{ taskId, taskType, roleId: targetName, comment },
	);

	const tasks = await getAwardTasks(submissionId);

	const filteredTasks = isNonEmptyArray(tasks) ? tasks.filter(({ id }) => id !== taskId) : [];
	awardTasksFactory.setData(filteredTasks);

	setCertificationIsFetching(false);

	return filteredTasks;
};

export const completeCertificationProposalTask = async (taskId, submissionId, taskType, targetName, comment) => {
	setCertificationIsFetching(true);

	let tasks = [];

	try {
		await completeCertificationTask(
			api.proposal.updateCertifications,
			{ id: submissionId },
			{ taskId, taskType, roleId: targetName, comment },
		);

		tasks = await getProposalTasks(submissionId);

	} catch (error) {
		const message = store.getState().dictionary.errors.unableToSave || "Unable to complete the certification";
		notifyError(message, error);
	}

	const filteredTasks = isNonEmptyArray(tasks) ? tasks.filter(({ id }) => id !== taskId) : [];
	proposalTasksFactory.setData(filteredTasks);

	setCertificationIsFetching(false);

	return filteredTasks;
};
